import SectionMessage from '@atlaskit/section-message';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const CloudMigrationTrialOfferBanner = ({ account }) => (
  <SectionMessage appearance="discovery">
    <span>
      <strong>
        <FormattedMessage
          id="mac.licenses.cloud.migration.title"
          defaultMessage="Cloud migration trial offer"
        />
      </strong>
      <br />
      <FormattedMessage
        id="mac.licenses.cloud.migration.description"
        defaultMessage="Atlassian would like to offer you a no-cost cloud migration trial for the {cloudProductDescription} Standard plan. This trial is good for up to {usageLimit} {unitLabel}"
        values={{
          usageLimit: account?.migrationEvaluationDTO?.usageLimit,
          unitLabel: account?.migrationEvaluationDTO?.unitLabel,
          cloudProductDescription: account?.migrationEvaluationDTO?.cloudProductDescription,
        }}
      />
      <br />
      <a
        href={`https://atlassian.com/try/cloud/signup?bundle=${account?.migrationEvaluationDTO?.bundleKey}&migrationSourceUuid=${account?.migrationEvaluationDTO?.migrationSourceUuid}&source=mac`}
      >
        <FormattedMessage id="mac.licenses.cloud.migration.start" defaultMessage="Start my trial" />
      </a>
      <br />
      <a href="https://www.atlassian.com/cloud-migration/explore-cloud">
        <FormattedMessage id="mac.licenses.cloud.migration.learn" defaultMessage="Learn more" />
      </a>
      <br />
      <i>
        <FormattedMessage
          id="mac.licenses.cloud.migration.trial.only"
          defaultMessage="The trial is only for use by this company."
        />
      </i>
    </span>
  </SectionMessage>
);
